import { Injectable } from '@angular/core';
import { ApiBaseService } from '@shared/services/entities/api-base.service';
import { StockModel } from '@shared/models/entities/stock.model';

@Injectable({ providedIn: 'root' })
export class SpecialtyService extends ApiBaseService<any> {
  constructor() {
    super('specialties');
  }
}